module.exports = __webpack_public_path__ + "static/media/brd.92fea245.svg";